import {LOGIN} from '../constants/constants'
import {database} from '../firebase'
import {algoErrado} from '../actions/sistema'
import { doLoad, finishLoad } from "../actions/request";

export default ({dispatch}) => next => action => {
    if(action.type===LOGIN){
        dispatch(doLoad())
        database.ref('/usuarios/').on('value', (snap)=>{
            let v = snap.val()
            console.log('login.js middlewares', v)
            let i = v.findIndex(x => x.usuario == action.usuario && x.senha === action.senha && parseInt(x.nivel) == 3)
            if(i>-1){
                next(action)
                dispatch(algoErrado(false))
            }
            else{
                dispatch(algoErrado())
            }
            dispatch(finishLoad())
        })
    }
    else next(action)
}


// WEBPACK FOOTER //
// ./src/middlewares/login.js